import { createFileRoute } from '@tanstack/react-router'
import { AgentSwarmDashboard } from '../../components/agent-swarm/AgentSwarmDashboard'

export const Route = createFileRoute('/dev/agent-swarm')({
  component: AgentSwarmDashboard,
})
